module.exports = __webpack_public_path__ + "static/media/AB_search_grey.6fdbe069.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/basic-slider/AB_search_grey.png
// module id = 1083
// module chunks = 0